import React from 'react';
import AppBarContainer from './app-bar-container';
import PostContainer from './post-container/post-container';

function App() {
  return (
    <div>
      <AppBarContainer />
      <PostContainer />
    </div>
  );
}

export default App;
